<template>
    <div>
        <Headers :title="title" />
        <van-row style="padding:0 .28rem .28rem .28rem">
            <van-col  class="exhibitior-wrap"  v-for="(item, index) in guestList" :key="index" span="8" >
                <template>
                    <div class="exhibitior-content">
                        <img :src="item.image" alt="" class="guest-img">
                        <div class="guest-name">{{item.name}}</div>
                        <div class="guest-post">{{(item.post)}}</div>
                    </div>
                </template>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
// import Footers from "./components/Footers";
import { mapState } from "vuex";
import api from "@/api";

export default {
    
    data(){
        return{
            loading: false,
            finished: false,
            // title: '嘉宾介绍',
            guestList: []
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return  this.language == 'zh' ?  '嘉宾介绍' : 'Guest Introduction'
        },
        ...mapState(["userInfo","language"]),
    },
    created() {
        this.getGuestInfo();
    },
    mounted(){
    },
    methods: {
        goPavilionDetaile(_id,_exhibition_id,_vhall_id){
            this.$router.push({
                path: '/mobilezhanquDetaile',
                query: {
                    company_id: _id,
                    exhibition_id: _exhibition_id,
                    instance_id: _vhall_id
                }
            })
        },
        onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                for (let i = 0; i < 10; i++) {
                this.list.push(this.list.length + 1);
                }

                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if (this.list.length >= 40) {
                this.finished = true;
                }
            }, 1000);
        },
        getGuestInfo(){
            api.getGuestInfo()
            .then(res=>{
                // console.log(res)
                if(res.res==1){
                    this.guestList = res.list
                    // console.log( this.guestList)
                }
            })
        }
    },
    components: {
        Headers
    },
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}

.allExhi{
    margin: .3rem 0 .18rem .3rem;
    font-size: 12px;
    color: #333333;
    line-height: .32rem;
}
.exhibitior-wrap{
    &:nth-child(odd){
        margin: .16rem .14rem .16rem 0;
    }
    &:nth-child(even){
        margin: .16rem 0;
    }
    height: 3.4rem;
    width: 3.4rem;
    background: #fff;
    border: 1px solid #e1e1ed;
    border-radius: 6px;
    .exhibitior-content{
        height: 3.4rem;
        width: 3.4rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .guest-img{
            width: 1.52rem;
            height: 1.52rem;
            border-radius: 50%;
            margin-top: .4rem;
            // background: #eee;
            
        }
        .guest-name{
            line-height: .42rem;
            color: #333;
            font-size: 16px;
            font-weight: 400;
            margin-top: .18rem;
        }
        .guest-post{
            line-height: .32rem;
            color: #999;
            font-size: 12px;
            font-weight: 400;
            margin-top: .12rem;
            margin-bottom: .4rem;
            padding: 0 .1rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileGuest/index.vue